module.exports = __webpack_public_path__ + "static/media/close-icon.c1e8dea5.svg";